import { VueAngularEventBus } from '@/angularBridge/eventBus'

export default {
  namespaced: true,
  actions: {
    fireEvent: function (store, event) {
      console.log('fireEvent', event)
      VueAngularEventBus.$emit(event.name, event.data)
    }
  },
  getters: {},
  mutations: {}
}
